import { each } from '../components/objects';

each(document.querySelectorAll('.js-close-alert'), function(_, el) {
  el.addEventListener('click', function(event) {
    event.preventDefault();
    
    let alert_node = this.parentElement,
        container  = alert_node.parentElement;
    
    if (container.querySelectorAll('.alert').length > 1)
      alert_node.remove();
    else
      container.remove();
  });
});



// WEBPACK FOOTER //
// ./app/javascript/components_common/close-alert.js